module.exports = __webpack_public_path__ + "pcstatic/img/book3.0d3e45a.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image2/book3.png
// module id = iK6F
// module chunks = 34